import { ContactHealthStatus, ListFilters } from '@/types';

export interface ContactFilter {
    health: ContactHealthStatus | null;
}

export interface ContactState extends ListFilters {
    filter: ContactFilter;
}

export enum ContactMutations {
    SET_SEARCH = 'contact_setSearch',
    SET_SORT = 'contact_setSort',
    SET_PAGE = 'contact_setPage',
    SET_FILTER = 'contact_setFilter',
}

export enum ContactActions {
    SET_SEARCH = 'contact_setSearch',
    SET_SORT = 'contact_setSort',
    SET_PAGE = 'contact_setPage',
    SET_FILTER = 'contact_setFilter',
}

export enum ContactGetters {
    SEARCH = 'contact_search',
    SORT = 'contact_sort',
    PAGE = 'contact_page',
    FILTER = 'contact_filter',
    DEFAULT_FILTER = 'contact_defaultFilter',
}
